import * as React from 'react';
import { RowDataRawOrder } from 'src/reducers/completeorderfile';
import OrderRawDataView from '../layouts/OrderRawDataView';
// import { UserDetail } from '../../reducers/user';

export interface OrderRawDataPageProps {
    onComponentDidMount: () => void;
    orderrawdata: RowDataRawOrder[];
    orderrawdataExport: RowDataRawOrder[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;

    fDate: (fromDate: Date | null) => void;
    toDate: (todate: Date | null) => void;

    startDate: Date | null;
    endDate: Date | null;

    dateFilter: () => void;
    dateReset: () => void;

    isDownloading: boolean;
    onBulkDownload: () => void;
    onBulkDownloadStl: () => void;
    onBulkDownloadIndividual: () => void;
    // Add missing props here
    failedFiles: Array<{ fname: string; orderno: string }>;
    showFailedFilesDialog: boolean;
    failedFilesMessage: string;
    closeFailedFilesDialog: () => void;

}

class OrderRawDataPage extends React.Component<OrderRawDataPageProps> {
    render() {
        return (
            <OrderRawDataView
                orderrawdata={this.props.orderrawdata}
                orderrawdataExport={this.props.orderrawdataExport}
                reload={this.props.reload}
                onRowClick={this.props.onRowClick}
                fDate={this.props.fDate}
                toDate={this.props.toDate}
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                dateFilter={this.props.dateFilter}
                dateReset={this.props.dateReset}
                isDownloading={this.props.isDownloading}
                onBulkDownload={this.props.onBulkDownload}
                onBulkDownloadStl={this.props.onBulkDownloadStl}
                // onBulkDownloadIndividual={this.props.onBulkDownloadStl}
                onBulkDownloadIndividual={this.props.onBulkDownloadIndividual}
                // Add these new props
                failedFiles={this.props.failedFiles}
                showFailedFilesDialog={this.props.showFailedFilesDialog}
                failedFilesMessage={this.props.failedFilesMessage}
                closeFailedFilesDialog={this.props.closeFailedFilesDialog}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
    }
}

export default OrderRawDataPage;



// WEBPACK FOOTER //
// ./src/components/OrderRawDataPage/OrderRawDataPage.tsx